module.exports = new __parcel__URL__("shivanna.a08b7288.jpg").toString();